import React from 'react';
import { Char, Root } from './HandwritingText.styles';

export interface HandwritingTextProps {
  text: string;
  className?: string;
  /** false 면 즉시 전체 표시 (애니메이션 없음) */
  animate?: boolean;
  /** animate=true 일 때 true 가 되면 글자별 등장 시작 */
  playing?: boolean;
  /** 첫 글자 시작 지연(ms) */
  startDelay?: number;
  /** 글자 간격(ms) */
  charDelay?: number;
}

/**
 * 손글씨 느낌의 글자별 등장 텍스트.
 * HS산토끼체 등 display 폰트와 함께 쓰면 필기체 연출에 가깝다.
 */
export function HandwritingText({
  text,
  className,
  animate = true,
  playing = false,
  startDelay = 0,
  charDelay = 52,
}: HandwritingTextProps) {
  const chars = Array.from(text);
  const mode = !animate ? 'instant' : playing ? 'playing' : 'pending';

  const getCharTilt = (index: number): 0 | 1 | 2 | undefined => {
    if (mode !== 'playing') return undefined;
    const n = index % 3;
    if (n === 0) return 0;
    if (n === 1) return 1;
    return 2;
  };

  return (
    <Root className={className}>
      {chars.map((char, index) => (
        <Char
          key={`${char}-${index}`}
          $pending={mode === 'pending'}
          $playing={mode === 'playing'}
          $tilt={getCharTilt(index)}
          style={
            animate && playing
              ? { animationDelay: `${startDelay + index * charDelay}ms` }
              : undefined
          }
          aria-hidden="true"
        >
          {char === ' ' ? '\u00A0' : char}
        </Char>
      ))}
    </Root>
  );
}
